import { useState } from 'react';
import AdminService from './AdminService';

function useManageAdmins() {
    const [admins, setAdmins] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const refreshAdmins = async () => {
        setIsLoading(true);
        try {
            const response = await AdminService.getAdmins();
            setAdmins(response.data);
            setError(null);
        } catch (err) {
            console.log(err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    const refreshAvailableUsers = async () => {
        try {
            const response = await AdminService.getAvailableUsers();
            setAvailableUsers(response.data);
        } catch (err) {
            console.log(err);
        }
    };

    const addAdmin = async (adminData) => {
        let result = true;
        setIsLoading(true);
        try {
            await AdminService.addAdmin(adminData);
            refreshAdmins();
            refreshAvailableUsers();
        } catch (err) {
            result = false;
            setError(err.response?.data?.message || 'An error occurred.');
        } finally {
            setIsLoading(false);
        }
        return result;
    };

    const editAdmin = async (adminId, updatedData) => {
        setIsLoading(true);
        try {
            await AdminService.editAdmin(adminId, updatedData);
            refreshAdmins();
            refreshAvailableUsers();
        } finally {
            // No catch: the caller shows the server's message. Swallowing it here
            // made a failed save report "Admin updated successfully!".
            setIsLoading(false);
        }
    };

    const deleteAdmin = async (adminId) => {
        setIsLoading(true);
        try {
            await AdminService.deleteAdmin(adminId);
            refreshAdmins();
            refreshAvailableUsers();
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        admins,
        availableUsers,
        isLoading,
        error,
        addAdmin,
        editAdmin,
        deleteAdmin,
        refreshAdmins,
        refreshAvailableUsers
    };
}

export default useManageAdmins;

